module.exports = __webpack_public_path__ + "static/media/branding-img8.280f47e7.jpg";